module.exports = __webpack_public_path__ + "img/广州知识塔.168022a7.png";